import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';

import { withTags } from '../../../hocs';
import {
  TagsSelect as TagsSelectImpl,
  TagsSelectStateProps,
} from '../components/tagsSelect';

const mapStateToProps = (state: RootReducerStateT): TagsSelectStateProps => ({
  agent: state.settings.profile.profile,
});

const TagsSelectWithTags = withTags(TagsSelectImpl, { pageSize: 25 });

export const TagsSelect = connect(mapStateToProps)(TagsSelectWithTags);
